export const AUTH_TOKEN = 'auth_token'
export const AUTH_ROLE = 'auth_role'